/* eslint-disable react/no-danger */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import attrib from "../util";
import "../../css/editorial.scss";

const Editorial = ({ details }) => {
  document.title = `Queer in Color | From the Founding Editor`
  return (
    <section className="editorial">
      <p id="editor">{details.editor}</p>
      <div id="full">
        <div className="intro" dangerouslySetInnerHTML={{ __html: attrib(details.intro) }} />
        <br />
        <div className="credit" dangerouslySetInnerHTML={{ __html: attrib(details.credit) }} />
        <br />
        <div className="resources" dangerouslySetInnerHTML={{ __html: attrib(details.resources) }} />
        <br />
        <p id="sign">
          Sincerely,<br />
          Jessica Kwon<br />
          <span id="founder">Founding Editor</span>
        </p>
        <div className="button-space">
          <Link to="/">
            <button type="button" className="back">
              <span className="return">RETURN</span> TO HOME &#x2197;
            </button>
          </Link>
        </div>
      </div>
    </section>
  )
}

Editorial.propTypes = {
  details: PropTypes.shape({
    editor: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    credit: PropTypes.string.isRequired,
    resources: PropTypes.string.isRequired
  })
}

Editorial.defaultProps = {
  details: undefined
}

export default Editorial;
